import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobFile } from "@/types";

export function useGetJobFiles() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["files", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/files`;
      const res = await guacHttpClient.get<JobFile[], HttpResponse<JobFile[]>>(
        path,
      );
      return res.data;
    },
  });
}
